import { FormControl, FormControlLabel, FormGroup, Switch } from '@material-ui/core';
import React from 'react';
import { useFormikContext } from 'formik';


export const ReportTogglerGroup = ({ options = [], onToggle }) => {
  const { values } = useFormikContext();
  
  return (
    <FormControl component="fieldset">
      <FormGroup row>
        {options.map((option) => {
          return (
            <FormControlLabel
              key={option.name}
              control={<Switch checked={!!values[option.name]} onChange={onToggle} name={option.name} />}
              label={option.label}
            />
          );
        })}
      </FormGroup>
    </FormControl>
  );
};